import React, { FC, useContext } from "react";
import { AppContext } from "context/app";
import { Footer } from "@pepdirect/v3/ui/Footer";
import {
  getFooterBranding,
  getSortedFooterLinks,
} from "@pepdirect/v3/helpers/footer";
import { endpoints } from "config";

export const NavFooter: FC = () => {
  const { tenant } = useContext(AppContext);

  const branding = getFooterBranding(
    tenant?.brandConfig?.customizations?.contacts || [],
    tenant?.brandConfig?.customizations?.images || []
  );

  const links = getSortedFooterLinks(
    tenant?.brandConfig?.customizations?.links || [],
    endpoints.web
  );

  const FooterData = {
    branding,
    copyright: {
      brandName: tenant?.brandConfig?.copyright || "",
      localization: { allRightsReserved: "All rights reserved." },
    },
    navigation: [{ links }],
  };

  return <Footer {...FooterData} />;
};
